// Common
import { Component, OnInit, OnDestroy, Input, ElementRef } from '@angular/core';

// RX
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Types
import { Project } from '@modules/tasks/types/project';
import { SectionTaskAppearance } from '@modules/tasks/types/section-task-appearance';
import { Section } from '@modules/common/types/section';

// Services
import { BoardService } from '@modules/tasks/services/board.service';
import { SplitViewService } from '@modules/split-view/services/split-view.service';

@Component({
  selector: 'app-project-board',
  templateUrl: './project-board.component.html',
  styleUrls: ['./project-board.component.less'],
  standalone: false,
})
export class ProjectBoardComponent implements OnInit, OnDestroy {
  @Input() project: Project;

  public tasksAppearance: SectionTaskAppearance;
  public sections: Section[] = [];

  private alive = new Subject<void>();

  constructor(
    private boardService: BoardService,
    private element: ElementRef,
    private splitViewService: SplitViewService,
  ) {}

  /**
   * Lifecycle
   */

  ngOnInit() {
    this.boardService
      .getSections()
      .pipe(takeUntil(this.alive))
      .subscribe((sections) => {
        this.sections = sections;
      });

    this.splitViewService
      .getSizeChanges()
      .pipe(takeUntil(this.alive))
      .subscribe(() => this.calculateAppearance());

    this.calculateAppearance();
  }

  ngOnDestroy(): void {
    this.alive.next();
    this.alive.complete();
  }

  /**
   * Helpers
   */

  calculateAppearance() {
    const size = this.element.nativeElement.getBoundingClientRect().width;

    if (size < 660) {
      this.tasksAppearance = 'board-small';
    } else if (size >= 660 && size < 1008) {
      this.tasksAppearance = 'board-medium';
    } else {
      this.tasksAppearance = 'board-large';
    }
  }

  /**
   * Actions
   */

  addSection() {
    this.boardService.addSection();
  }
}
